import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import Typography from "@mui/material/Typography"
import React from "react"

import { getPaymentMethodLabel } from "../../../../utils/paymentMethodLabels"
import DefaultPaymentMethodSwitch from "../../../shared/DefaultPaymentMethodSwitch"
import { PaymentTypeMethodActiveToggle } from "../PaymentTypeMethodActiveToggle"

import { type CompanyPaymentTypeMethod, CompanyStatus } from "@/graphql/codegen/graphql"
import { usePaymentTermsContext } from "@/screens/CompanySettings/Accounting/contexts/PaymentTermsContext"

interface NonBankingPaymentMethodProps {
  method: CompanyPaymentTypeMethod | null
  onDefaultChange?: (paymentMethod: CompanyPaymentTypeMethod) => void
  toggleMethodActivation: () => void
}

const NonBankingPaymentMethod: React.FC<NonBankingPaymentMethodProps> = ({
  method,
  onDefaultChange,
  toggleMethodActivation,
}) => {
  const { companyStatus } = usePaymentTermsContext()
  const isCompanyActiveStatus = companyStatus === CompanyStatus.Active

  if (!method) {
    return null
  }

  return (
    <Card variant='outlined' className='flex items-center justify-between border border-gray-300 bg-white p-6'>
      <Typography className='text-ml font-normal text-gray-900'>
        {getPaymentMethodLabel(method.method)} Transaction
      </Typography>

      <Box className='flex items-center gap-4'>
        {isCompanyActiveStatus && (
          <PaymentTypeMethodActiveToggle
            onChange={toggleMethodActivation}
            isActive={method.status !== CompanyStatus.Inactive}
          />
        )}
        <DefaultPaymentMethodSwitch
          checked={method.isDefault}
          disabled={method.status !== CompanyStatus.Active}
          onChange={() => onDefaultChange?.(method)}
        />
      </Box>
    </Card>
  )
}

export default NonBankingPaymentMethod
